<dialog-draggable-header *ngIf="isNew">Add Authority</dialog-draggable-header>
<dialog-draggable-header *ngIf="!isNew">Update Authority</dialog-draggable-header>
<div mat-dialog-content>
   <form class="flex-dialog-container" [formGroup]="addAuthorityForm">
      <mat-form-field>
         <mat-label>Authority #(alpha)</mat-label>
         <input  matInput autocomplete="off" formControlName="authNumber" #authNumber (keyup.enter)="authAlphaFieldCheck($event)"
            (blur)="authAlphaFieldCheck($event)" oninput="this.value = this.value.toUpperCase()" />
         <mat-error *ngIf="authNumber.value?.length > 20">Cannot exceed 20 characters.</mat-error>
         <mat-error *ngIf="addAuthorityForm.controls.authNumber.hasError('avoType')">
            Cannot have Auth Number if AVO type
         </mat-error>
         <mat-error *ngIf="addAuthorityForm.controls.authNumber.hasError('required')">
            Auth Number is required if not AVO Type
         </mat-error>
      </mat-form-field>

      <mat-form-field>
         <mat-label>Authority #(numeric)</mat-label>
         <input matInput autocomplete="off" formControlName="authNumberN" #authNumberN
            oninput="this.value = this.value.toUpperCase()" />
         <mat-error *ngIf="addAuthorityForm.controls.authNumberN.hasError('required')">Required</mat-error>
         <mat-error *ngIf="authNumberN.value?.length > 20">Cannot exceed 20 characters.</mat-error>
      </mat-form-field>

      <mat-form-field>
         <mat-label>Authority Type</mat-label>

         <mat-select formControlName="authTypeName" (selectionChange)="authTypeFieldCheck($event)">
            <mat-option  *ngFor="let at of authTypes" [value]="at.authTypeName">
               {{at.authTypeName}}
            </mat-option>
         </mat-select>
         <mat-error *ngIf="addAuthorityForm.controls.authTypeName.hasError('required')">Required</mat-error>
      </mat-form-field>

      <mat-form-field>
         <mat-label>Authority Description</mat-label>
         <input matInput autocomplete="off" formControlName="authDescription" #authDescription
            oninput="this.value = this.value.toUpperCase()" />
         <mat-error *ngIf="authDescription.value?.length > 500">Cannot exceed 500 characters.</mat-error>
      </mat-form-field>

   </form>

</div>
<div mat-dialog-actions class="mat-dialog-actions-end no-margin">
   <button mat-raised-button color="primary" (click)="onAddClick()" (keypress.enter)="onAddClick()"
      [disabled]="addAuthorityForm.invalid">Save</button>
   <button mat-raised-button mat-dialog-close cdkFocusInitial (click)="onCancelClick()"
      (keypress.enter)="onCancelClick()">Cancel</button>
</div>